module.exports = __webpack_public_path__ + "static/media/id-badge.5203f38e.svg";